import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
config({ licenseKey });

import './plugins/axios'
import { createPinia } from 'pinia'

import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.dark.css';
import './themes/generated/theme.base.css';
// import './themes/generated/theme.base.dark.compact.css';
// import './themes/generated/theme.base.compact.css';
import './themes/generated/theme.additional.dark.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";

import App from "./App";
import appInfo from "./app-info";

// import DevExpress from "devextreme/bundles/devexpress.all";
import 'devextreme/dist/css/dx.light.css';
// console.log("DevExpress loaded:", DevExpress);

themes.initialized(() => {
    const app = createApp(App);
    app.use(router);
    app.use(createPinia())
    app.config.globalProperties.$appInfo = appInfo;
    app.mount('#app');
});
